/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Accesstokenforstudents3Inputs */

const de__field_accesstokenforstudents3 = /** @type {(inputs: _Field_Accesstokenforstudents3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token für Schüler:innen`)
};

/**

* @param {_Field_Accesstokenforstudents3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_accesstokenforstudents3 = /** @type {((inputs?: _Field_Accesstokenforstudents3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Accesstokenforstudents3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_accesstokenforstudents3(inputs)
});
export { _field_accesstokenforstudents3 as "_field_accessTokenForStudents" }